const assign = (o) => Object.assign({}, o)
const empties = [undefined, "", null, "null", {}, []];
import { isEmpty, isNotEmpty } from "@/utils/util"
import UserAccountSelect from '@/components/common/UserAccountSelect'
import Vue from 'vue'
export default {
    name: 'PartyTemp7',
    components: {
        UserAccountSelect
    },
    data() {
        return {
            temp: {
                contractId: 1, //这个是不用的
                "beginPlace": "",
                "contractNum": "",
                "deadweight": "",
                "deliveryWay": "",
                "demurrageAmount": "",
                "endPlace": "",
                "goodsCount": "",
                "goodsLose": "",
                "goodsName": "",
                "hatchHoldCapacity": '',
                "homePort": "",
                "isTax": "",
                "laydaysDate": '',
                "leastTon": "",
                "loadDay": "",
                "loadDraught": "",
                "note": "",
                "pack": "",
                "packageCount": '',
                "palletAccount": "",
                "palletAddTime": '',
                "palletBank": "",
                "palletName": "",
                "payWay": "",
                "prepayment": '',
                "price": '',
                "rule": "",
                "shipLengthWidth": "",
                "shipName": "",
                "shipType": "",
                "shipperAccount": "",
                "shipperAddTime": '',
                "shipperBank": "",
                "shipperName": "",
                "specificClauseContent": "",
                "specificClauseExtra": "",
                "specificClauseName": "",
                "totalNetWeight": "",
                "unloadDay": "",
                "volume": "",
                "voyage": ""
            },
            d: {
            },

            laydaysDateStr: '',
            shipperAddTimeStr: '',
            palletAddTimeStr: '',

            specificClauseList: [
                {
                    content: "1、本合同经双方盖章后支付合同定金后合同生效；未足额支付定金的本合同不生效，且已付定金没收。合同通过传真、微信、邮件、平台数据传输签订，具有书面合同同等法律效力；合同生效后，一方不履行合同或发生船货落空，违约方应当按照合同总运费的30%赔偿另一方违约金。\n\n2、托运人负责组织合法货源，提供一个安全装卸货泊位或锚地；若改港或移泊需经承运人书面盖章确认，所产生费用由托运人承担；托运人购买货物保险，船货方港口费用各负其责。\n\n3、承运人船舶应符合适航要求，负责船舶在受载期内船舶抵港；承担货物防火、防水、防盗责任；将货物安全运送至指定港口；合同约定的船舶无法按时抵港的，在不影响受载期的情况下，承运人有权更换同类型船舶。\n\n4、装卸时间两港合并计算（包括节假日），装卸时间从船舶抵达首个锚地时起算，至装卸完最后一码货物时为止；直靠码头的从靠码头时起算；若需外锚地侯泊，侯泊时计算，但外锚地至码头航行时间不计算装卸时间；超过装卸时间托运人应按合同约定按天计算支付滞期费，不足一天的按比例计算；一旦滞期永远滞期，但因恶劣天气等不可抗力因素造成封航、作业中断，滞期费各承担一半。",
                    note: ''
                }
            ],
            agreementType: [],
            formData: [{
                id: '',
                type: 1, //合同性质
                numb: null, // 合同号
                title: null, // 订单标题
                busType: null, // 业务类型
                addTime: null, // 签约日期
                addWay: 1,//签约方式
                buyerName: null, // 托运人名称
                sellerName: null, // 承运人名称
                amountTotal: null, // 总金额
                fileUuidList: []
            }],
            goodsList: [
                {
                    goodsName: null, // 货名
                    rule: null, // 规格
                    unit: null, // 单位
                    counts: null, // 数量
                    price: null, // 单价
                    isTax: null, // 是否含税
                    carShipNum: null, // 车船号
                    deliveryPoints: null, // 交货地点
                    beginPlace: null, // 起运地
                    endPlace: null, // 到达地
                    beginTime: null // 交货日期
                }
            ],
        }
    },
    created() {
        this.d = assign(this.temp)
    },
    methods: {
        init(agreementType, formData, goodsData, carShipData, specificClauseList) {
            this.d = assign(this.temp)
            //合同类型  可用来区分 账户接口
            this.agreementType = agreementType

            //合同主体
            if (isNotEmpty(formData)) {
                this.d.contractNum = formData.numb
                if (isNotEmpty(formData.buyerInfo)) {
                    this.d.palletName = isEmpty(formData.buyerInfo.compName) ? formData.buyerInfo.realName : formData.buyerInfo.compName
                    this.d.palletUserId = formData.buyerInfo.id
                } else {
                    this.d.palletName = formData.buyerName
                }
                if (isNotEmpty(formData.sellerInfo)) {
                    this.d.shipperName = isEmpty(formData.sellerInfo.compName) ? formData.sellerInfo.realName : formData.sellerInfo.compName
                    this.d.shipperUserId = formData.sellerInfo.id
                } else {
                    this.d.shipperName = formData.sellerName
                }
                this.shipperAddTimeStr = formData.addTime
                this.palletAddTimeStr = formData.addTime
            }

            //货品信息
            if (!isEmpty(goodsData)) {
                this.d = Object.assign(this.d, {
                    goodsName: goodsData.goodsName,
                    goodsCount: goodsData.counts, // 数量  
                    rule: goodsData.rule, // 规格 
                    shipName: goodsData.carShipNum, // 车船号
                    deliveryPoints: goodsData.deliveryPoints, // 交货地点
                    beginPlace: goodsData.beginPlace, // 起运地
                    endPlace: goodsData.endPlace, // 到达地
                    laydaysDateStr: goodsData.beginTime, // 交货日期
                    isTax: goodsData.isTax == 1 ? '是' : (goodsData.isTax == 0 ? '否' : ''),
                    price: goodsData.price
                })
                this.laydaysDateStr = goodsData.beginTime
            }

            //航次信息
            if (!isEmpty(carShipData)) {
                this.d = Object.assign(this.d, {
                    shipName: carShipData.shipName,
                    homePort: carShipData.homePort,
                    shipType: carShipData.shipType,
                    deadweight: carShipData.deadweight,
                    totalNetWeight: carShipData.totalweight + '/' + carShipData.netweight,
                    shipLengthWidth: carShipData.shipLength + '/' + carShipData.shipWidth,
                    loadDraught: carShipData.loadDraught,
                })
            }
            //获取航次租船模板数据  specificClause
            this.specificClauseList = specificClauseList
            specificClauseList.forEach(item => {
                if (item.isDefault == 1) {
                    this.d.specificClauseName = item.note
                    this.d.specificClauseContent = item.dictText
                }
            });

            //购买方 和承运人 的银行账户列表 默认就第一个吧Buyer
            this.$refs.palletBank.init(this.agreementType == 'Seller' ? 'platform' : 'user', this.d.palletUserId, this.d.palletName, 'palletBank')
            this.$refs.shipperBank.init(this.agreementType == 'Buyer' ? 'platform' : 'user', this.d.shipperUserId, this.d.shipperName, 'shipperBank')

        },
        //返回选择的银行账户
        selectUserAccount(cate, row) {
            if (cate == 'palletBank') {
                this.d.palletBank = row.bankName
                this.d.palletAccount = row.accountNum
            } else {
                this.d.shipperBank = row.bankName
                this.d.shipperAccount = row.accountNum
            }
        },
        changeSpecificClauseContent(content) {
            this.d.specificClauseContent = content
        },
        returnData() {
            this.d.laydaysDateStr = this.laydaysDateStr
            this.d.shipperAddTimeStr = this.shipperAddTimeStr
            this.d.palletAddTimeStr = this.palletAddTimeStr
            return this.d
        },
    },
}